export default __webpack_public_path__ + "static/media/f10.55ab4747.jpg";